<script setup lang="ts">
const { model } = defineProps(['model'])
const open = ref(false)
const state = reactive({
  email: undefined,
})

function onSubmit() {
  open.value = true
}
</script>

<template>
  <div class="newsletter-block block-spacing">
    <div class="container-fluid">
      <div class="newsletter-block__grid card-shadow rounded-xl prose">
        <div
          v-if="model?.aprimoIcon?.url"
          class="newsletter-block__icon-wrap not-prose"
        >
          <NuxtImg
            :src="model.aprimoIcon?.url"
            :alt="model.iconAltText?.value"
            loading="lazy"
            class="newsletter-block__icon"
          />
        </div>
        <div class="newsletter-block__content-wrap">
          <div class="newsletter-block__content">
            <h2
              v-if="model?.title?.value"
              class="mt-0"
            >
              {{ model.title.value }}
            </h2>
            <div v-html="model?.summary?.value" />
          </div>
          <div class="newsletter-block__form">
            <UForm
              :state="state"
              class="md:border-med-dark-gray md:border-2 rounded-[13px] flex flex-col gap-[24px] md:flex-row md:gap-0"
              @submit="onSubmit"
            >
              <UFormField
                label=""
                name="email"
                class="w-full gap-0"
              >
                <UInput
                  v-model="state.email"
                  variant="outline"
                  size="lg"
                  :placeholder="model?.placeholderText?.value"
                  :ui="{
                    base: 'shadow-none rounded-xl md:ring-0 md:bg-transparent focus-visible:ring-0 placeholder:text-gray-400',
                  }"
                  aria-label="enter email"
                  required
                  type="email"
                />
              </UFormField>
              <UButton
                color="primary"
                variant="solid"
                class="cursor-pointer justify-center min-w-20"
                label="Submit"
                type="submit"
                :onclick="() => {}"
                aria-label="Submit"
              />
            </UForm>
            <UModal
              v-model:open="open"
              :title="model.title?.value"
              aria-describedby="subscription form"
              description=""
              :close="{
                variant: 'outline',
                color: 'primary',
                class: 'rounded-full min-w-auto border-med-deep-navy',
              }"
            >
              <template #body>
                <OneEightyFormBlock
                  v-show="open"
                  :model="{ ...model, blockSpacing: false, formTitle: model.title }"
                  :prefill="{ email: state.email }"
                />
              </template>
            </UModal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @use '@/assets/css/blocks/newsletter-block.scss';
@use '@/assets/css/forms/hubspot-form.scss';
</style>
